<div class="modal-header">
  <h4 class="modal-title">Example Profile</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-xl-8">
      <div class="row">
        <div class="col-4 pr-0">
          <div class="rounded-border rounded-tight p-2" style="height: 300px">
            <img src="/assets/images/photo_placeholder.png"
                 class="customer-photo my-2">
            <p class="customer-name">{{ customerName() }}</p>
            <p class="customer-contact">{{ getFieldValue(organizationConfig.profile_contact_field) }}</p>
            <div class="row">
              <div class="col">
                <p class="main-item-value">{{ getFieldValue(organizationConfig.major_profile_field_1) }}</p>
                <p class="main-item-label">{{ getThisCustomerFieldLabel(organizationConfig.major_profile_field_1) }}</p>
              </div>
              <div class="col">
                <p class="main-item-value">{{ getFieldValue(organizationConfig.major_profile_field_2) }}</p>
                <p class="main-item-label">{{ getThisCustomerFieldLabel(organizationConfig.major_profile_field_2) }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-8">
          <div class="rounded-border rounded-tight p-2" style="height: 300px">
            <div class="row">
              <div class="col">
                <div class="d-flex flex-wrap">
                  <button *ngFor="let button of actionButtonOrder" type="button"
                          class="btn btn-sm btn-outline-primary mr-2 mb-2 text-nowrap">
                    {{ getCustomerProfileActionButtonLabel(button) }}
                  </button>
                </div>
              </div>
            </div>
            <div class="row mb-3 mt-2">
              <div class="col">
                <p class="grid-item-label">{{ getThisCustomerFieldLabel(organizationConfig.minor_profile_field_1) }}</p>
                <p class="grid-item-value">{{ getFieldValue(organizationConfig.minor_profile_field_1) }}</p>
              </div>
              <div class="col">
                <p class="grid-item-label">{{ getThisCustomerFieldLabel(organizationConfig.minor_profile_field_2) }}</p>
                <p class="grid-item-value">{{ getFieldValue(organizationConfig.minor_profile_field_2) }}</p>
              </div>
              <div class="col">
                <p class="grid-item-label">{{ getThisCustomerFieldLabel(organizationConfig.minor_profile_field_3) }}</p>
                <p class="grid-item-value">{{ getFieldValue(organizationConfig.minor_profile_field_3) }}</p>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <p class="grid-item-label">{{ getThisCustomerFieldLabel(organizationConfig.minor_profile_field_4) }}</p>
                <p class="grid-item-value">{{ getFieldValue(organizationConfig.minor_profile_field_4) }}</p>
              </div>
              <div class="col">
                <p class="grid-item-label">{{ getThisCustomerFieldLabel(organizationConfig.minor_profile_field_5) }}</p>
                <p class="grid-item-value">{{ getFieldValue(organizationConfig.minor_profile_field_5) }}</p>
              </div>
              <div class="col">
                <p class="grid-item-label">{{ getThisCustomerFieldLabel(organizationConfig.minor_profile_field_6) }}</p>
                <p class="grid-item-value">{{ getFieldValue(organizationConfig.minor_profile_field_6) }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <p class="grid-item-label">{{ getThisCustomerFieldLabel(organizationConfig.minor_profile_field_7) }}</p>
                <p class="grid-item-value">{{ getFieldValue(organizationConfig.minor_profile_field_7) }}</p>
              </div>
              <div class="col">
                <p class="grid-item-label">{{ getThisCustomerFieldLabel(organizationConfig.minor_profile_field_8) }}</p>
                <p class="grid-item-value">{{ getFieldValue(organizationConfig.minor_profile_field_8) }}</p>
              </div>
              <div class="col">
                <p class="grid-item-label">{{ getThisCustomerFieldLabel(organizationConfig.minor_profile_field_9) }}</p>
                <p class="grid-item-value">{{ getFieldValue(organizationConfig.minor_profile_field_9) }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-4 mt-3 mt-xl-0">
      <div class="rounded-border rounded-tight p-3 mb-3"
           *ngFor="let card of sidebarOrder">
        <p class="side-table-header">{{ getCustomerProfileSidebarCardLabel(card) }}</p>
        <table class="table">
          <tbody>
            <tr *ngFor="let row of getMockSidebarRows(card)">
              <td [innerHTML]="row.left"></td>
              <td *ngIf="row.right" class="text-muted text-right">{{ row.right }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">
    Close
  </button>
</div>
